import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LexusLayoutComponent } from './lexus-layout.component';
import { DashboardComponent } from '../shared/components/dashboard/dashboard.component';
import { LexusLayoutService } from './lexus-layout.service';
import { SharedModule } from '../shared/shared.module';
import { FlowInformationComponent } from '../shared/components/flow-information/flow-information.component';
import { PhoneManufacturerComponent } from '../shared/components/phone-manufacturer/phone-manufacturer.component';
import { environment } from '../../environments/environment';
import { PhoneCompatabilityComponent } from 'src/modules/shared/components/phone-compatability/phone-compatability.component';
import { MatDialogModule } from "@angular/material/dialog";
import { ErrorGuideTableComponent } from '../shared/components/error-guide-table/error-guide-table.component';
import { SearchResultsComponent } from '../shared/components/search-results/search-results.component';
import { SearchPageComponent } from '../shared/components/search-page/search-page.component';
import { HomeCarouselComponent } from '../shared/components/home-carousel/home-carousel.component';
import { FirstSetupComponent } from '../shared/components/first-setup/first-setup.component';
import { BtCompatabilityComponent } from '../shared/components/bt-compatability/bt-compatability.component';
import { MsalGuard } from '@azure/msal-angular';


const routes: Routes = [{
  path: '',
  component: LexusLayoutComponent,
  children: [
    {
      path: 'lexus',
      redirectTo: '',
      pathMatch: 'prefix'
    },
    {
      path: 'home',
      /* Changed the component regarding TCCP-1734 */
      //      component: VehicleModelComponent,
      component: HomeCarouselComponent,

    },
    {
      path: 'home/internal',
      component: HomeCarouselComponent,
      canActivate: [MsalGuard],
    },
    {
      path: 'dashboard',
      component: DashboardComponent,
    },
    {
      path: 'feature/:feature/:id',
      component: FlowInformationComponent,
    },

    {
      path: 'bluetooth-compatability',
      component: PhoneManufacturerComponent
    },
    {
      path: 'bluetooth-compatability/:model/:year',
      component: PhoneCompatabilityComponent
    },
    {
      path: 'error-guides',
      component: ErrorGuideTableComponent
    }, {
      path: 'search-results',
      component: SearchResultsComponent
    },
    {
      path: 'search-page',
      component: SearchPageComponent
    },
    {
      path: 'first-setup',
      component: FirstSetupComponent
    },
    {
      path: 'phone-compatability',
      component: BtCompatabilityComponent
    }
  ]
}
];

@NgModule({
  declarations: [LexusLayoutComponent],
  imports: [
    CommonModule, RouterModule.forChild(routes), TranslateModule,
    FormsModule, ReactiveFormsModule, SharedModule, MatDialogModule
  ],
  providers: [LexusLayoutService]
})
export class LexusLayoutModule { }
